import * as React from 'react';
import PageAccessCheck, { PageAccessCheckProps } from './PageAccessCheck';

type PageAccessProps = Omit<PageAccessCheckProps, 'children'>;

export const withPageAccessCheck =
  <P extends object>(Component: React.ComponentType<React.PropsWithChildren<P>>) =>
  (pageAccessProps: PageAccessProps) =>
  (props: P) => (
    <PageAccessCheck {...pageAccessProps}>
      <Component {...props} />
    </PageAccessCheck>
  );
